import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';
import { STATES } from '@itds/Constants';

const Details = ({ form, form_tags, product_groups, setVersion }) => {
  const styles = {
    component: {
      display: 'flex'
    },
    preview_container: {
      position: 'relative',
      paddingTop: '80%',
      width: 'calc(60% - 40px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f5f5f5'
    },
    preview: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none'
    },
    preview_404: {
      fontSize: 100,
      color: '#e5e5e5',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    details: {
      marginLeft: 40,
      width: '40%',
      flexShrink: 0
    },
    section: {
      marginBottom: 30
    },
    section_header: {
      color: Colors.BLUE.hex,
      textTransform: 'uppercase',
      fontSize: 11,
      letterSpacing: 1,
      fontWeight: 600,
      marginBottom: 10
    },
    button: {
      marginTop: 30
    },
    delete: {
      color: Colors.RED.hex,
      fontWeight: 600,
      cursor: 'pointer',
      textAlign: 'center',
      marginTop: 15
    }
  };

  // form.pdf_file.url = 'https://ixntestsa001.blob.core.windows.net/ixn-sand/ixn-data/forms/106/637f4f1d-6727-47d8-b772-ebc8c759224c.pdf';
  return (
    <div style={styles.component}>
      <div style={styles.preview_container}>
        {form.pdf_file && form.pdf_file.url ? (
          <iframe src={form.pdf_file.url} style={styles.preview} />
        ) : (
          <i className='mdi mdi-file-question' style={styles.preview_404} />
        )}
      </div>
      <div style={styles.details}>
        <div style={styles.section}>
          <div style={styles.section_header}>Number</div>
          <p>{form.number}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.section_header}>Description</div>
          <p>{form.description}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.section_header}>States</div>
          <p>
            {form.states
              .map(abbr => {
                const state = STATES.find(s => s.value === abbr) || {};

                return state.label;
              })
              .join(', ')}
          </p>
        </div>

        <div style={styles.section}>
          <div style={styles.section_header}>Tags</div>
          <p>
            {form.form_tag_ids
              .map(id => {
                const form_tag = form_tags.find(ft => ft.id === id) || {};

                return form_tag.name;
              })
              .join(', ')}
          </p>
        </div>

        <div style={styles.section}>
          <div style={styles.section_header}>Product Groups</div>
          <p>
            {form.product_group_ids
              .map(id => {
                const product_group = product_groups.find(pg => pg.id === id) || {};

                return product_group.group_name;
              })
              .sort()
              .join(', ')}
          </p>
        </div>

        <div style={styles.button}>
          <Button
            onClick={setVersion.bind(null, {
              name: form.name,
              number: form.number,
              description: form.description,
              states: form.states,
              form_tag_ids: form.form_tag_ids,
              product_group_ids: form.product_group_ids,
              file: form.pdf_file
            })}
          >
            Make Changes
          </Button>
        </div>
      </div>
    </div>
  );
};

Details.propTypes = {
  form: PropTypes.object,
  form_tags: PropTypes.array,
  product_groups: PropTypes.array,
  setVersion: PropTypes.func
};

export default Details;
